// *** Allows to overwriteCustomeAssignments chart opts and colors and ... ***
//
import { CUSTOM_CHART_COLORS, CUSTOM_CHART_OPTS } from './colors'
import { overwriteCustomAssignments } from './custom_assignments'

export function overwriteColors() {
  var opts = {
    watermark: false
  }

  var colors = {
    primary: '#005556',
    primaryDt: '#45B8A1',
    colormaps: {
      fromGridToPrimary: [
        '#6B7D8B',
        '#5F7786',
        '#546F80',
        '#48697B',
        '#3C6375',
        '#305D70',
        '#24576A',
        '#185165',
        '#0D4B5F',
        '#014559',
        '#005556'
      ],
      fromGridToPrimaryDt: [
        '#6B7D8B',
        '#62848C',
        '#588C8D',
        '#4E938D',
        '#459A8E',
        '#3CA18F',
        '#33A890',
        '#2AAE91',
        '#21B592',
        '#18BC93',
        '#45B8A1'
      ]
    },
    dashboard: {
      toGrid: '#005556',
      toGridDt: '#45B8A1',
      fromGrid: '#6B7D8B',
      fromGridDt: '#45B8A1',
      backgroundColorShowNodeTrue: '#005556',
      backgroundColorShowNodeTrueDt: '#45B8A1',
      nodeColor: '#005556',
      nodeColorDt: '#45B8A1',
      lineColors: {
        default: '#6B7D8B',
        defaultDt: '#6B7D8B'
      }
    },
    grid: {
      con: ['#45B8A1'],
      gen: ['#45B8A1']
    }
  }

  overwriteCustomAssignments(opts, CUSTOM_CHART_OPTS)
  overwriteCustomAssignments(colors, CUSTOM_CHART_COLORS)
}
